import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_debounced_function } from '@/hooks/debounce/use_debounced_function';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { useCallback } from 'react';

export function WatcherScreenResize() {
  const dispatch = use_dispatch();

  let on_resize_cached = useCallback(on_resize, []);
  let on_resize_debounced = use_debounced_function(on_resize_cached, 50);

  /*
   * EFFECTS
   */

  use_effect(() => {
    on_resize();

    window.resize_on(on_resize_debounced);

    return () => window.resize_off(on_resize_debounced);
  }, []);

  /*
   * EVENTS
   */
  function on_resize() {
    dispatch(LOCAL__ui_set_boolean({ value: screen.width <= 768, key: 'global_is_mobile' }));
    dispatch(LOCAL__ui_set_boolean({ value: screen.width > 1024, key: 'global_is_desktop' }));
    dispatch(LOCAL__ui_set_boolean({ value: screen.width > 768 && screen.width <= 1024, key: 'global_is_tablet' }));
  }

  return <></>;
}
